import { array, boolean, constant, Decoder, number, object, string, union } from '@mojotech/json-type-validation'

import { commentaryInfoDecoder } from '../commentary/commentaryInfoDecoder'

import { ProblemDescription } from '@/domain/entities/problem/problemDescription'

export const problemDescriptionDecoder: Decoder<ProblemDescription> = object({
  problem_id: string(),
  language: union(constant('ja'), constant('en')),
  html: string(),
  time_limit: number(),
  memory_limit: number(),
  commentaries: array(commentaryInfoDecoder),
  created_at: number().map(x => new Date(x)),
  server_time: number(),
  solvedUser: number(),
  successRate: number(),
  score: union(number(), constant(null)),
  recommend: union(boolean(), constant(null)),
  recommendations: number(),
  bookmarks: union(array(string()), constant(null)),
  isSolved: boolean(),
  source: union(string(), constant(null))
}).map(x => ({
  ...x,
  problemId: x.problem_id,
  timeLimit: x.time_limit,
  memoryLimit: x.memory_limit,
  createdAt: x.created_at,
  serverTime: x.server_time,
  displayLanguage: x.language === 'ja' ? 'Japanese' : 'English'
}))
